import { render, staticRenderFns } from "./pdialog.vue?vue&type=template&id=2f0fe224&"
import script from "./pdialog.vue?vue&type=script&lang=js&"
export * from "./pdialog.vue?vue&type=script&lang=js&"
import style0 from "./pdialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports